import StorageHelper from "../helpers/StorageHelper";

const storageHelper = new StorageHelper();

export class PlugBoletoApi {
  constructor(url) {
    this.url = url;
    const localStorageToken = storageHelper.getLocal("token");
    this.authorization = `Bearer ${localStorageToken}`;
  }

  async get(headers) {
    return fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
        ...headers,
      },
    });
  }

  async post(body, headers) {
    const response = await fetch(this.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
        ...headers,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  }

  async put(id, body, headers) {
    let urlPut = `${this.url}/${id}`;
    const response = await fetch(urlPut, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
        ...headers,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  }

  async delete(id, headers) {
    const urlDelete = `${this.url}/${id}`;
    const response = await fetch(urlDelete, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
        ...headers,
      },
    });
    return await response.json();
  }
}
